// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"62bb0bc8","128":"8ebb0839","144":"e4efa03b","240":"0929efd2","299":"bf942a8a","372":"1cf41bdd","497":"8bcf3616","610":"431dd902"}[chunkId] + ".chunk.js";
};